<dcu-body-content-list [id]="'cooperative-list'" [bodyContent]="bodyContent"></dcu-body-content-list>
